<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      :table_width="1800"
      title="신청 조회"
      desc="현재 신규로 들어온 신청 내역을 확인할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="2400"
                 nextPageName="nopage"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <h4 class="request-form" slot="forms" slot-scope="props">
        <div v-for="(form,form_idx) in props.item.forms" :key="'form-'+form_idx">
          <div v-for="(res,idx) in form.answers.result" :key="'res-'+idx" class="lp-meet-qna">
            <div>{{ idx+1 }}. {{ res.question }}</div>
            <div v-if="typeof(res.answer)==='string'">{{ res.answer }}</div>
            <div v-else v-for="(item,idx) in res.answer" :key="'item-'+idx" style="margin-bottom:4px">
              <div :style="imgField(item.file)"></div>
            </div>
          </div>
        </div>
        <!--<div @click.stop.prevent="clickContent(props.item)" style="cursor: pointer">
          <i class="material-icons">library_books</i>
        </div>-->
      </h4>

      <div slot="is_user" slot-scope="props">
        <div v-if="props.item.user.name">회원</div>
        <div v-else>비회원</div>
      </div>

      <div slot="user_name" slot-scope="props">
        <span v-if="props.item.user">{{ props.item.user.name }}</span>
      </div>

      <div slot="order_num" slot-scope="props">
        <span class="unselect" style="text-decoration: underline" @click="clickRequestDetail(props.item.id)">{{ props.item.order_num }}</span>
      </div>

      <div slot="product_name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="clickDetail(props.item.product.id, 'product')">{{ props.item.product_name }}</span>
      </div>

      <!-- 신청 확인 -->
      <div slot="request_status" slot-scope="props" style="width: 120px; margin: auto;">
        <button class="button request-status" @click="clickAccept(props.item)" v-if="props.item.status===0">확인하기</button>
        <button class="button is-danger" @click="clickDeny(props.item)" v-if="props.item.status===0">거절하기</button>

        <div v-if="props.item.status===101">
          <div>신청거절완료</div>
          <div>{{ props.item.deny_time }}</div>
        </div>

        <div v-else-if="props.item.status>0">
          <div>신청확인</div>
          <div>{{ props.item.request_time }}</div>
        </div>
      </div>

      <!-- 입금 확인 -->
      <div slot="deposit_status" slot-scope="props" style="width: 120px; margin: auto;" v-if="props.item.status!==101">
        <div>
          <!--<input class="input"-->
                 <!--:value="props.item.blank"-->
                 <!--@input="e => props.item.blank = e.target.value"-->
                 <!--type="text">-->
          <!--{{ props.item.blank }}-->
        </div>
        <button class="button" @click="clickDeposit(props.item)" v-if="props.item.status===1">입금확인하기</button>
        <div v-if="props.item.status>=2">입금완료</div>
        <div>{{ props.item.deposit_time }}</div>
      </div>

      <!-- 승인 여부 -->
      <div slot="meet_status" slot-scope="props" style="width: 120px; margin: auto;" v-if="props.item.status!==101">
        <div v-if="props.item.status===2">
          <button class="button meet-status" @click="clickMeet(props.item, 'approve')">승인</button>
          <button class="button" @click="clickMeet(props.item, 'approve_cancel')">미승인</button>
        </div>
        <div v-if="props.item.status===3">
          <div>승인완료</div>
          <div>{{ props.item.approve_time }}</div>
        </div>
        <div v-if="props.item.status===103">
          <div>승인취소</div>
          <div>{{ props.item.approve_cancel_time }}</div>
        </div>
      </div>

  <!--    <div slot="request_deny" slot-scope="props">
        <div v-if="props.item.status===2">
          <button class="button" @click="clickDeny(props.item)">신청거절</button>
        </div>
        <div v-if="props.item.status===101">
          <div>신청거절완료</div>
          <div>{{ props.item.deny_time }}</div>
        </div>
      </div>-->

      <div slot="refund_status" slot-scope="props" style="width: 120px; margin: auto;" v-if="props.item.status!==101">
        <div v-if="props.item.status===103">
          <div>
            <button class="button" @click.stop.prevent="clickRefund(props.item, '')">환불</button>
          </div>
          <div style="margin-top:4px">
            <button class="button is-danger" @click.stop.prevent="clickNoRefund(props.item)">환불없음</button>
          </div>
        </div>
        <div v-if="props.item.status===104">환불완료</div>
        <div v-else-if="props.item.status===105">환불없음</div>
        <div v-if="props.item.refund_time">{{ props.item.refund_time }}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half is-danger" @click.stop.prevent="clickModifyDelete(props.item,'delete')">삭제</button>
      </div>
    </admin-table>

    <!-- 상담 신청서 모달 -->
    <modal name="requestModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="모임 신청서 조회" :useTab="false" v-if="selectedItem">
          <div v-for="(form,idx) in selectedItem.forms" :key="'form-'+idx">
            <admin-form-item :label="form.title">
              <div v-for="(res,idx) in form.answers.result" :key="'res-'+idx" class="lp-meet-qna">
                <div>{{ idx+1 }}. {{ res.question }}</div>
                <div v-if="typeof(res.answer)==='string'">{{ res.answer }}</div>
                <div v-else>
                  <div class="align-center flex" v-for="(item,idx) in res.answer" :key="'item-'+idx" style="margin-bottom:4px">
                    <a style="padding-bottom:8px;font-size:13px;text-decoration:underline" :href="item.file" target="_blank">{{ item.name }}</a>
                  </div>
                </div>
              </div>
            </admin-form-item>
          </div>
        </admin-box-item>
      </div>
    </modal>


  </div>
</template>

<script>
  import moment from 'moment';
  import ListMixin from '@/mixins/ListMixin';

  export default {
    name: 'MeetRequestNew',
    mixins: [
      ListMixin
    ],
    computed: {
      partnerName(){
        let partner_id;
        if(this.selectedItem){
          partner_id = this.selectedItem.partner_id;
        }
        else if(this.requestItem){
          partner_id = this.requestItem.partner_id;
        }
        let partner = find(this.partners, 'value', partner_id);
        if(partner !== undefined)
          return partner.name;
        else
          return '';
      }
    },

    data () {
      return {
        selectedItem: undefined,    // 팝업으로 표시할 선택된 아이템
        partners: []
      }
    },

    created () {
      this.init();
    },

    methods: {
      init() {
        this.initializing('meet_request', 'meet/request');
        this.filtered.start =  moment().format('YYYY-MM-DD');
      },
      getDataFromServer() {
        this.getData();
      },
      clickRequestDetail(id){
        this.$router.push(this.getPath(`meet/request/detail?id=${id}`));
      },
      clickDetail(id, type) {
        if( type === 'product' ) {
          window.open(this.getPath(`product/create?id=${id}`));
        }
      },
      clickStatus(item, kind) {
        if (kind === "confirm-new") {
          this.chkReq(item);
        }
        else if (kind === "request-sheet") {
          this.clickAddRequest(item);
        }
        else if (kind === "write-sheet") {
          this.clickAddBid(item);
        }
      },

      // 상담 신청서 보기
      clickContent(item) {
        this.selectedItem = item;
        this.$modal.show('requestModal');
      },

      // 신청 확인하기
      clickAccept(item) {
        this.$axios.post(this.getUrl(`meet/request/${item.id}/accept`)).then(res=>{
          if(res.status===200) {
            item.status=1;
            item.request_time = moment().format('YYYY-MM-DD HH:mm')
          }
        })
      },

      clickNoRefund(item) {
        this.$axios.post(this.getUrl(`meet/request/${item.id}/no_refund`)).then(res=> {
          if(res.status===200) {
            item.status=105;
            item.refund_time = moment().format('YYYY-MM-DD HH:mm');
          }
        })
      },

      clickRefund(item) {
        this.$axios.post(this.getUrl(`meet/request/${item.id}/refund`)).then(res=> {
          if(res.status===200) {
            item.status=104;
            item.refund_time = moment().format('YYYY-MM-DD HH:mm');
          }
        })
      },

      clickDeposit(item) {
        this.$axios.post(this.getUrl(`meet/request/${item.id}/deposit`)).then(res=> {
          if(res.status===200) {
            item.status=2;
            item.deposit_time = moment().format('YYYY-MM-DD HH:mm')
          }
        }).catch(error => {
          if (error.response) {
            this.toast(error.response.data.message);
          }
        })
      },

      // 승인, 미승인 클릭시
      clickMeet(item, type) {
        let status = 3;
        if(type==='approve_cancel') {
          status = 103;
        }
        this.$axios.post(this.getUrl(`meet/request/${item.id}/${type}`)).then(res=>{
          if(res.status===200) {
            item.status=status;
            if (type==='approve') {
              item.approve_time = moment().format('YYYY-MM-DD HH:mm');
            }
            else {
              item.approve_cancel_time = moment().format('YYYY-MM-DD HH:mm');
            }
          }
        })
      },

      clickDeny(item) {
        this.$axios.post(this.getUrl(`meet/request/${item.id}/deny`)).then(res=> {
          if(res.status===200) {
            item.status = 101;
            item.deny_time = moment().format('YYYY-MM-DD HH:mm');
          }
        })
      },


      // 견적 상태 - 신규요청확인 클릭
      chkReq(item) {
        this.$axios.post(this.getUrl('meet/request/'+item.id+'/receipt'),{
          status:1
        }).then(res => {
          if(res.status===200){
            item.status = 1;
          }
        });
      },

      clickModifyDelete(item, type) {
        if(type === 'delete') {
          let value = {
            url: `meet/request/${item.id}`,
            title: `index ${item.id}번 모임 신청을 삭제하시겠습니까?`
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-meet-qna
    margin-bottom 8px

  .lp-meet-qna:last-child
    margin-bottom 0

  .request-status
    background-color #fcb100
    color white

  .meet-status
    background-color $primary
    color white

  .request-form
    text-align left
    font-size 12px
    line-height 15px
</style>
